import { render, staticRenderFns } from "./editProductDrawer.vue?vue&type=template&id=60d9227f&scoped=true"
import script from "./editProductDrawer.vue?vue&type=script&lang=js"
export * from "./editProductDrawer.vue?vue&type=script&lang=js"
import style0 from "./editProductDrawer.vue?vue&type=style&index=0&id=60d9227f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d9227f",
  null
  
)

export default component.exports